<template>
  <div class="eventDetails">
    <el-dialog
      class="customDialog"
      :title="dialogTitle || '详情'"
      :visible.sync="isShow"
      width="620px"
      top="15vh"
      :close-on-click-modal = 'false'
      :close-on-press-escape = 'false'
    >
      <div class="formContainer" v-if="detailsData">
        <div class="title">
          <img src="~@/assets/images/eventDetails.png" alt="">
          <span>{{detailsData.name}}</span>
        </div>
        <div class="content">
          <p>
            <span class="label">事件地点：</span>
            <span class="value">{{detailsData.address}}</span>
          </p>
          <p>
            <span class="label">拍摄时间：</span>
            <span class="value">{{new Date(detailsData.captureTime).format('yyyy/MM/dd hh:mm:ss')}}</span>
          </p>
          <p>
            <span class="label">事件类型：</span>
            <span class="value">{{detailsData.eventType}}</span>
          </p>
          <p>
            <span class="label">拍摄人员：</span>
            <span class="value">{{detailsData.photographer}}</span>
          </p>
          <p>
            <span class="label">状态：</span>
            <span class="value">{{detailsData.group==='OTHER'?'已完成':'新发现'}}</span>
          </p>
          <p>
            <span class="label">经度：</span>
            <span class="value">{{detailsData.longitude}}</span>
          </p>
          <p>
            <span class="label">纬度：</span>
            <span class="value">{{detailsData.latitude}}</span>
          </p>
          <p>
            <span class="label">事件描述：</span>
            <span class="value">{{detailsData.description || '无'}}</span>
          </p>
          <p>
            <span class="label">备注：</span>
            <span class="value">{{detailsData.remark || '无'}}</span>
          </p>
          <p>
            <span class="label">成果：</span>
            <span class="value" v-if="detailsData.attachments && JSON.parse(detailsData.attachments).length">
              <span class="imgBox" v-for="(item,index) in JSON.parse(detailsData.attachments)" :key="index"  @click="preview(index)">
                <img :src="item.url" alt="png" v-if="item.format === 'image'">
                <img :src="item.url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_32,h_32'" alt="png" v-if="item.format === 'video'">
                <span class="shade" v-if="item.format === 'video'"><i class="el-icon-caret-right"></i></span>
              </span>
            </span>
            <span style="color: white" v-else>无</span>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">关闭</el-button>
      </span>
    </el-dialog>
    <PreviewPicture ref="PreviewPicture"></PreviewPicture>
  </div>
</template>

<script>
import { getEventDetails, getEventSelect } from '@/api/demandManagement'
import PreviewPicture from '@/components/PreviewPicture/PreviewPicture'
export default {
  name: 'eventDetails',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: { PreviewPicture },
  data () {
    return {
      isShow: false,
      dialogTitle: '',
      dialogType: '',
      dialogRow: '',
      detailsData: null
    }
  },
  computed: {
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    // 参数为标题，类型和数据
    open (title, type, row) {
      this.dialogTitle = title
      this.dialogType = type
      this.dialogRow = row
      this.isShow = true
      this.getEventDetails()
    },
    cancel () {
      this.isShow = false
    },
    preview (index) {
      this.$refs.PreviewPicture.open(JSON.parse(this.detailsData.attachments), index)
    },
    getEventDetails () {
      getEventDetails({ id: this.dialogRow.id }).then((res) => {
        if (res.code === 200) {
          this.detailsData = res.data
          this.getEventSelect()
        }
      })
    },
    getEventSelect () {
      getEventSelect().then((res) => {
        this.detailsData.eventType = res.data[this.detailsData.eventType]
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .eventDetails{
    .formContainer{
      .title{
        width: 576px;
        height: 60px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        box-sizing: border-box;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #FFFFFF;
        >img{
          margin-right: 12px;
        }
      }
      .content{
        width: 576px;
        height: auto;
        border: 1px dashed rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        margin-top: 12px;
        padding: 20px;
        box-sizing: border-box;
        overflow-y: auto;
        >p{
          text-align: left;
          line-height: 15px;
          display: flex;
          align-items: start;
          .label{
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #999999;
            display: inline-block;
            width: 70px;
            text-align: right;
          }
          .value{
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #FFFEFE;
            display: inline-block;
            width: calc(100% - 70px);
            line-height: 1.2;
            letter-spacing: 1.5px;
            >.imgBox{
              width: 100px;
              height: 100px;
              border-radius: 6px;
              display: inline-block;
              margin-right: 20px;
              position: relative;
              overflow: hidden;
              cursor: pointer;
              &:last-child{
                margin-right: 0;
              }
              >img{
                width: 100%;
                height: 100%;
              }
              >.shade{
                width: 100%;
                height: 100%;
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, 0.5);
                font-size: 26px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
</style>
